<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-row justify-center items-center">

      <div class="vx-col p-20">
        <div class="mb-5 text-left">
          <img src="@/assets/images/logo/logo-w.svg" alt="CFC Solutions" class="fill-current stroke-current text-white inline-block">
        </div>
        <h1 class="d-theme-text-inverse text-2xl md:text-4xl mb-5">Outil de gestion &amp; <br>suivi de facturation</h1>
        <h4 class="d-theme-text-inverse text-opacity-75 font-normal">Le plus court chemin <br>de la facture au règlement</h4>
      </div>

      <div class="vx-col">
        <vx-card>
          <div slot="no-body" class="full-page-bg-white rounded-lg d-theme-dark-bg">
            <div class="p-10 login-tabs-container">

              <div class="vx-card__title mb-4">
                <h4 class="mb-4">Récupération du mot de passe</h4>
                <p>Pour récupérer le mot de passe, veuillez saisir votre email:</p>
              </div>

              <div>
                <form action="#" @submit.prevent="" @keydown.enter="validadeFields ? dorecover(): false">
                  <vs-input
                    v-validate="'required|email'"
                    data-vv-validate-on="change|input|keyup"
                    name="email"
                    icon-no-border
                    icon="icon icon-mail"
                    icon-pack="feather"
                    placeholder="votre email"
                    v-model="email"
                    class="w-full mt-8"/>
                  <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                  <div class="flex flex-wrap justify-between my-5">
                    <router-link class="my-2" to="/pages/login"><i class="far fa-arrow-left mr-2"></i>Retour à la page de login</router-link>
                    <vs-button :disabled="!validadeFields" @click="dorecover" class="float-right">Envoyer</vs-button>
                  </div>
                </form>
              </div>

            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// For custom error message
import { Validator } from 'vee-validate'
const dict = {
  custom: {
    email: {
      required: 'Merci de saisir un email',
      email: 'Le format d’email n’est pas valide'
    }
  }
}

// register custom messages
Validator.localize('fr', dict)

export default {
  data () {
    return {
      email: ''
    }
  },
  computed: {
    ...mapGetters('user', ['activeUser']),
    validateForm () {
      return !this.errors.any() && this.email !== ''
    },
    validadeFields () {
      return (!this.errors.any() && this.email !== '')
    }
  },
  methods: {
    ...mapActions('user', ['recoverpass']),

    dorecover () {

      if (!this.validateForm) return

      this.$vs.loading()
      this.error = false

      this.recoverpass({email: this.email})
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    }
  }
}
</script>

<style lang="scss">
    .login-tabs-container{
        max-width: 623px;
    }
</style>
